import { ArrowRightOutlined, ClockCircleOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dateFromString } from "../../../../../utils/dateFromString";
import { Button, DatePicker, Modal, Popconfirm } from "antd";
import { useParams } from "react-router";
import { handleDate } from "../../../../../utils/dandleDate";
import locale from "antd/es/date-picker/locale/es_ES";
import {
  startUpdateEstatus,
  startUpdateServicioPT,
} from "../../../../../context/actions/ptActions";

export const RecolectandoDoc = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [newDate, setNewDate] = useState();
  const { estatusId, fechaRecolectandoDocumentos } = useSelector(
    (state) => state.ptReducer.ptDetalle.servicioPT
  );

  const handleClick = () =>
    dispatch(startUpdateEstatus({ id, estatusId: estatusId + 1 }));

  const changeDate = () => {
    const body = {
      fechaRecolectandoDocumentos: newDate,
      id,
    };
    dispatch(startUpdateServicioPT(body));
    setOpenModal(false);
  };

  if (estatusId === 2)
    return (
      <Popconfirm
        title="Avanzar Servicio"
        description="¿Confrmas que ya los documentos necesarios han sido revisados?"
        onConfirm={handleClick}
        onCancel={() => {}}
        okText="Confirmo que si"
        cancelText="No, déjame verificar de nuevo"
      >
        <Button shape="round"  size="small" danger>
          <ArrowRightOutlined />
        </Button>
      </Popconfirm>
    );

  if (estatusId >= 3)
    return (
      <div>
        <ClockCircleOutlined />
        <span
          style={{ cursor: "pointer", paddingLeft: 3 }}
          onClick={() => setOpenModal(true)}
        >
          {dateFromString(fechaRecolectandoDocumentos).dateStep}
        </span>
        <Modal
          open={openModal}
          title="Cambiar fecha"
          onCancel={() => setOpenModal(false)}
          onOk={changeDate}
        >
          <DatePicker
            showTime
            locale={locale}
            style={{ marginTop: 20 }}
            onChange={(val, strVal) => setNewDate(handleDate(val))}
          />
        </Modal>
      </div>
    );

  return <></>;
};
